
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {TradingCentralNewsArticle} from './TradingCentralNewsArticle';
import {FieldModelTradingCentralNewsArticle} from './TradingCentralNewsArticle';

/**
 * NewsArticleGetResponse struct
 */
class NewsArticleGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {TradingCentralNewsArticle=} tradingCentralArticle
   * @constructor
   */
  constructor (parent = new Response(), tradingCentralArticle = null) {
    super()
    super.copy(parent)
    this.TradingCentralArticle = tradingCentralArticle
  }

  /**
   * Copy struct (shallow copy)
   * @this {!NewsArticleGetResponse}
   * @param {!NewsArticleGetResponse} other Other struct
   * @returns {!NewsArticleGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.TradingCentralArticle != null) {
      this.TradingCentralArticle = TradingCentralNewsArticle.fromObject(other.TradingCentralArticle)
    } else {
      this.TradingCentralArticle = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!NewsArticleGetResponse}
   * @returns {!NewsArticleGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new NewsArticleGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new NewsArticleGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!NewsArticleGetResponse}
   * @param {!NewsArticleGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof NewsArticleGetResponse)) {
      throw new TypeError('Instance of NewsArticleGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!NewsArticleGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      TradingCentralArticle: ((this.TradingCentralArticle != null) ? this.TradingCentralArticle : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return NewsArticleGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!NewsArticleGetResponse} other Object value
   * @returns {!NewsArticleGetResponse} Created struct
   */
  static fromObject (other) {
    return new NewsArticleGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!NewsArticleGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return NewsArticleGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!NewsArticleGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5216
  }
}

export { NewsArticleGetResponse };

/**
 * Fast Binary Encoding NewsArticleGetResponse field model
 */
class FieldModelNewsArticleGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.TradingCentralArticle = new fbe.FieldModelOptional(new FieldModelTradingCentralNewsArticle(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelNewsArticleGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelNewsArticleGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelNewsArticleGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.TradingCentralArticle.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelNewsArticleGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.TradingCentralArticle.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelNewsArticleGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelNewsArticleGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelNewsArticleGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5216
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelNewsArticleGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelNewsArticleGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.TradingCentralArticle.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradingCentralArticle.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradingCentralArticle.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelNewsArticleGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelNewsArticleGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelNewsArticleGetResponse}
   * @param {!NewsArticleGetResponse} fbeValue Default value, defaults is new NewsArticleGetResponse()
   * @returns {!NewsArticleGetResponse} NewsArticleGetResponse value
   */
  get (fbeValue = new NewsArticleGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelNewsArticleGetResponse}
   * @param {!NewsArticleGetResponse} fbeValue NewsArticleGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.TradingCentralArticle.fbeSize) <= fbeStructSize) {
      fbeValue.TradingCentralArticle = this.TradingCentralArticle.get()
    } else {
      fbeValue.TradingCentralArticle = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradingCentralArticle.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelNewsArticleGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelNewsArticleGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelNewsArticleGetResponse}
   * @param {!NewsArticleGetResponse} fbeValue NewsArticleGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelNewsArticleGetResponse}
   * @param {NewsArticleGetResponse} fbeValue NewsArticleGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.TradingCentralArticle.set(fbeValue.TradingCentralArticle)
  }
}

export { FieldModelNewsArticleGetResponse };

/**
 * Fast Binary Encoding NewsArticleGetResponse model
 */
class NewsArticleGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelNewsArticleGetResponse(this.buffer, 4)
  }

  /**
   * Get the NewsArticleGetResponse model
   * @this {!NewsArticleGetResponseModel}
   * @returns {!FieldModelNewsArticleGetResponse} model NewsArticleGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!NewsArticleGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!NewsArticleGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return NewsArticleGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!NewsArticleGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelNewsArticleGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!NewsArticleGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!NewsArticleGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!NewsArticleGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!NewsArticleGetResponseModel}
   * @param {!NewsArticleGetResponse} value NewsArticleGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!NewsArticleGetResponseModel}
   * @param {!NewsArticleGetResponse} value NewsArticleGetResponse value, defaults is new NewsArticleGetResponse()
   * @return {!object} Deserialized NewsArticleGetResponse value and its size
   */
  deserialize (value = new NewsArticleGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new NewsArticleGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new NewsArticleGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!NewsArticleGetResponseModel}
   * @param {!number} prev Previous NewsArticleGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { NewsArticleGetResponseModel };
